{
  "name": "oms-admin-webapp",
  "version": "1.7.0-beta.89",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:andre": "ng serve --host=0.0.0.0 --disable-host-check --configuration=andre --port 4800",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.1",
    "@angular/cdk": "^21.2.1",
    "@angular/common": "^21.2.1",
    "@angular/compiler": "^21.2.1",
    "@angular/core": "^21.2.1",
    "@angular/forms": "^21.2.1",
    "@angular/material": "^21.2.1",
    "@angular/platform-browser": "^21.2.1",
    "@angular/platform-browser-dynamic": "^21.2.1",
    "@angular/router": "^21.2.1",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "angular-oauth2-oidc": "^20.0.2",
    "angular-oauth2-oidc-jwks": "^20.0.0",
    "bootstrap": "^5.3.8",
    "deepmerge": "^4.3.1",
    "file-saver": "^2.0.5",
    "js-sha256": "^0.11.1",
    "lottie-web": "^5.12.0",
    "ngx-auth-util-lib": "3.0.0",
    "ngx-heka-design-lib": "4.0.0",
    "ngx-lottie": "^21.2.0",
    "ngx-mat-select-search": "^8.0.4",
    "ngx-progressbar": "^14.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.16.1"
  },
  "devDependencies": {
    "@angular/build": "^21.2.0",
    "@angular/cli": "~21.2.0",
    "@angular/compiler-cli": "^21.2.0",
    "@types/node": "^20.1.0",
    "typescript": "~5.9.3"
  }
}
